'use client';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Image from 'next/image';
import Link from 'next/link';
import { signOut, useSession } from 'next-auth/react';
import React, { useState } from 'react';

import SignInOrRegisterModal from '../modals/SignInOrRegisterModal';

const ProfileSection = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const { data: session } = useSession();

  return (
    <div className="relative">
      <button
        onClick={toggleDropdown}
        type="button"
        className="inline-flex items-center space-x-2 rounded-lg bg-transparent px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        <AccountCircleIcon />
        <span className="text-white">會員中心</span>
        <svg
          className="ms-3 h-2.5 w-2.5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 10 6"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m1 1 4 4 4-4"
          />
        </svg>
      </button>

      {dropdownOpen && (
        <div className="absolute right-0 z-10 mt-2 w-44 divide-y divide-gray-100 rounded-lg bg-white shadow">
          <div className="px-4 py-3 text-sm text-gray-900 ">
            <div className="truncate font-medium">{session?.user?.email}</div>
          </div>
          <ul
            className="py-2 text-sm text-gray-700 dark:text-gray-200"
            aria-labelledby="dropdownInformationButton"
          >
            <li>
              <Link href="/dashboard">
                <div className="block cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                  會員資料
                </div>
              </Link>
            </li>

            <li>
              <Link href="/dashboard/upload-license-plate">
                <div className="block cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                  上架車牌
                </div>
              </Link>
            </li>
            <li>
              <Link href="/dashboard/upload-car">
                <div className="block cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                  上架二手車
                </div>
              </Link>
            </li>
            <li>
              <Link href="/dashboard/user-profile">
                <div className="block cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white">
                  會員設定
                </div>
              </Link>
            </li>
          </ul>
          <div className="py-2">
            <div
              onClick={() => signOut()}
              className="block cursor-pointer px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              登出
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

interface RegisterOrLoginButtonProps {
  setOpenSignInOrRegisterModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const RegisterOrLoginButton: React.FC<RegisterOrLoginButtonProps> = ({
  setOpenSignInOrRegisterModal,
}) => {
  return (
    <button
      onClick={() => setOpenSignInOrRegisterModal(true)}
      className="block rounded-lg  bg-gray-300 bg-opacity-25 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-gray-300 focus:outline-none focus:ring-4 focus:ring-blue-300  "
      type="button"
    >
      登入 / 註冊
      <AccountCircleIcon />
    </button>
  );
};

const Navbar = () => {
  const { data: session } = useSession();
  const [openSignInOrRegisterModal, setOpenSignInOrRegisterModal] =
    useState<boolean>(false);

  console.log('navbar get session:', session);
  const isAuthenticated = !!session?.user;

  return (
    <nav className="w-full">
      <div className="flex w-full flex-row justify-end">
        <SignInOrRegisterModal
          isOpen={openSignInOrRegisterModal}
          setIsOpen={setOpenSignInOrRegisterModal}
        />
        <div className="flex items-center justify-between">
          <ul className="mt-4 flex flex-col rounded-lg p-4 text-xl font-medium rtl:space-x-reverse md:mt-0 md:flex-row md:space-x-8 md:border-0">
            <Link href="/" className="text-xl font-bold text-white">
              PairCar
            </Link>
            <li>
              <Link
                href="/used-cars"
                className="block rounded px-3 py-2 text-white"
              >
                買車
              </Link>
            </li>
            <li>
              <Link
                href="/search"
                className="block rounded px-3 py-2 text-white"
              >
                智能搜尋
              </Link>
            </li>
            <li>
              {isAuthenticated ? (
                <Link
                  href="/dashboard/upload-car"
                  className="block rounded px-3 py-2 text-white"
                >
                  賣車
                </Link>
              ) : (
                <div
                  onClick={() => setOpenSignInOrRegisterModal(true)}
                  className="block cursor-pointer rounded px-3 py-2 text-white"
                >
                  賣車
                </div>
              )}
            </li>
            <li>
              <Link
                href="/articles"
                className="block rounded px-3 py-2 text-white"
              >
                文章
              </Link>
            </li>
          </ul>
        </div>
        <div className="flex items-center space-x-3 rtl:space-x-reverse md:order-2 md:space-x-0">
          {isAuthenticated ? (
            <ProfileSection />
          ) : (
            <RegisterOrLoginButton
              setOpenSignInOrRegisterModal={setOpenSignInOrRegisterModal}
            />
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
